import topicsMethods from './Topics'

export const TopicServices = {
  ...topicsMethods
}

export * from './Topics.types'
